<template lang="pug">
  .field-vehicle-id(v-if="$is('vehicle-id')")
    .field-value V{{item.id}}
  .field-vehicle-image(v-else-if="$is('vehicle-image')")
    .field-value
      img(:src="item.picture_external")
  .field-vehicle-brand-and-lot(v-else-if="$is('vehicle-brand-and-lot')")
    .field-value(v-if="item.archived_at" style="color:red") Archived
    .field-value {{item.brand}} {{item.model}}
    .field-value {{item.parking_lot.name}}

  .field-vehicle-lot(v-else-if="$is('vehicle-lot')")
    .field-value(v-if="item.parking_lot.name") PL {{item.parking_lot.name}}
    .field-value(v-if="item.vehicle_slot_address" style="max-width: fit-content;") VS{{item.slot_id}} {{item.vehicle_slot_address}}
    .field-value(v-if="item.federation !== null") Federation: {{item.federation.name}}
  .field-vehicle-brand(v-else-if="$is('vehicle-brand')")
    .field-value {{item.brand}} {{item.model}}

  .field-vehicle-lot(v-else-if="$is('vehicle-lot-address')")
    .field-value.mb-1(v-if="item.vehicle_slot_address") VS{{item.slot_id}} {{item.vehicle_slot_address}}
    .field-value(v-if="item.federation !== null") Federation: {{item.federation.name}}
  .field-vehicle-brand(v-else-if="$is('vehicle-brand')")
    .field-value {{item.brand}} {{item.model}}

  .field-vehicle-plate(v-else-if="$is('vehicle-plate')")
    .field-value
      router-link.hollow.button.secondary.small(:to="{name:'vehicle', params:{id:item.id}}") {{item.plate}}
  .field-vehicle-fuel-type(v-else-if="$is('vehicle-fuel-type')")
    .label Fuel Type
    .field-value {{item.fuel_type}}
  .field-vehicle-category(v-else-if="$is('vehicle-category')")
    .label Category
    .field-value {{item.category.name}}
  .field-vehicle-lot(v-else-if="$is('vehicle-lot')")
    .label Assigned lot
    .field-value {{item.slot_name}}
  .field-vehicle-status(v-else-if="$is('vehicle-status')")
    .label Status &nbsp;
      span.float-right.fa.fa-circle(
        v-if="item.slot_id !== null",
        :class="pointStatusColor"
      )

    vehicle-status(:item="item")
  .field-vehicle-additional-status(v-else-if="$is('vehicle-additional-status')")
    vehicle-additional-status(:item="item")

</template>
<script type="text/babel">
import Status from '../Status.vue'
import Driver from '../../../backoffice/Driver.vue'
import Vehicle from '../../../backoffice/Vehicle.vue'
import VehicleStatus from '../VehicleStatus.vue'
import VehicleAdditionalStatus from "../VehicleAdditionalStatus";

export default {
  name: 'VehicleFields',
  components: {
    VehicleStatus,
    Vehicle,
    Driver,
    Status,
    VehicleAdditionalStatus
  },
  data() {
    return {}
  },
  created() {
  },
  methods: {
  },
  computed: {
    type() {
      return this.fieldName
    },
    pointStatusColor: function () {
      return {
        'orange-status': this.item.has_reservation === 'normal',
        'yellow-status': this.item.has_reservation  === 'maintenance',
        'red-status':!!this.item.slot_disabled,
        'green-status':!this.item.slot_disabled
      }
    }
  },
  props: {
    item: Object,
    fieldName: {
      type: String,
      default: ''
    }
  },
}
</script>
<style lang="sass" rel="stylesheet/sass">
.field-vehicle-status
  min-width: max-content

  .green-status
    color: #27803e

  .red-status
    color: red

  .orange-status
    color: orange

  .green-status.orange-status
    color: darkorange

  .yellow-status
    color: #ffe811
</style>



// WEBPACK FOOTER //
// VehicleFields.vue?476b3003